import React, { useEffect } from 'react';
import PrivacyPageMain from '../../presentation/section/footer-link-page/PrivacyPageMain';

const Privacy = (props) => {
  useEffect(() => {
    window.scrollTo(0,0)
  }, [])

  return (
    <PrivacyPageMain />
  )
}

export default Privacy;